exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-label-group[data-v-41d54f63]{min-width:0;display:flex;align-items:center}.fts-label-group .label-group__emoji[data-v-41d54f63]{margin-right:.375rem}.fts-label-group .label-group__icon[data-v-41d54f63]{margin-right:.375rem;color:#ef6c00}.fts-label-group .label-group__icon.label-group__icon--system[data-v-41d54f63]{color:#2b9ec6}.fts-label-group .label-group__label[data-v-41d54f63]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports
